import {
  HalfPaddedFormSectionContent,
  RadioButton,
  RadioLabel,
  RadioOption,
} from 'modules/workflowNodeEditors/EditorBody.styled';
import { TipPlacement } from 'ui/tooltip';
import { colors } from 'ui/theme';
import { AttributionMode } from 'modules/workflows/types';
import noop from 'utils/noop';
import { ATTR_MODE_OPTIONS_MULTIPLE_CONVERSIONS } from '../../BaseSendEditor.constants';
import { StyledToggletipCentered } from '../../BaseSendEditor.styles';
import { CHILD_VALUE_LOOKUP } from './MultipleConversionSelection.constants';

export interface MultiRadioProps {
  value?: AttributionMode;
  onChange?: (mode: AttributionMode) => void;
  isDisabled?: boolean;
}

export const MultiRadio = ({
  value: mode,
  onChange = noop,
  isDisabled = false,
}: MultiRadioProps) => {
  return (
    <HalfPaddedFormSectionContent>
      {ATTR_MODE_OPTIONS_MULTIPLE_CONVERSIONS.map(({ prefix, suffix, tooltip, value }) => (
        <RadioOption key={`option-${value}`}>
          <RadioButton
            id={value}
            value={value}
            isChecked={mode === value}
            onClick={() => onChange(value)}
            isDisabled={isDisabled}
          />
          <RadioLabel onClick={() => onChange(value)}>
            {prefix} {CHILD_VALUE_LOOKUP[value]} {suffix}
          </RadioLabel>
          {tooltip && (
            <StyledToggletipCentered
              placement={TipPlacement.Bottom}
              tooltipContent={tooltip}
              iconProps={{ color: colors.secondaryText }}
            />
          )}
        </RadioOption>
      ))}
    </HalfPaddedFormSectionContent>
  );
};

export default MultiRadio;
